<template>
  <div class="pop">
    <!-- 儲值确认 / 支付成功 -->
    <div class="pop-container make-sure-container">
      <div class="pop-container-title">
        <div class="title-wrap">
          <div class="title-icon"></div>
          <span class="title-text">{{ title }}</span>
        </div>
        <div
          class="pop-close"
          @click="closeOrderConfirm"
          :ga-data="gadata"
        ></div>
      </div>
      <!-- 商品信息 -->
      <div class="product">
        <div
          class="product-img"
          :style="{
            'background-image': 'url(' + data.product_icon + ')',
          }"
        ></div>
        <div class="product-name">{{ data.product_name }}</div>
        <div class="product-desc" v-if="data.marketing_desc1 || data.marketing_desc2">
          <div>
            <p v-if="data.marketing_desc1">{{ data.marketing_desc1 }}</p>
            <p v-if="data.marketing_desc2">{{ data.marketing_desc2 }}</p>
          </div>
        </div>
      </div>
      <!-- 提示信息 -->
      <div class="info">
        <div class="info-img"></div>
        <span class="info-text">{{ tipInfo }}</span>
      </div>
      <!-- 文案区域 确认弹窗 -->
      <div class="text-container">
        <div class="text-item">
          <span class="t-title">{{ $t("paygame.paygameName") }}</span>
          <span class="one-line t-text">{{ data.game_name }}</span>
        </div>
        <div class="text-item">
          <span class="t-title">{{ $t("paygame.account") }}</span>
          <span class="one-line t-text">{{ data.account }}</span>
        </div>
        <div class="text-item">
          <span class="t-title">{{ $t("paygame.gameRole") }}</span>
          <span class="two-line t-text"
            >{{ data.cp_role_name }}（ID:{{ data.cp_role_id }}）</span
          >
        </div>
        <div class="text-item">
          <span class="t-title">{{ $t("paygame.payWay") }}</span>
          <span class="one-line t-text">{{ data.payment_desc }}</span>
        </div>
        <div class="text-item">
          <span class="t-title">{{ $t("paygame.payAmount") }}</span>
          <span class="one-line t-money"
            ><span class="payAmount">{{ data.product_price }}</span
            ><span class="payCurrency">({{ data.currency }})</span></span
          >
        </div>
        <div class="text-item"  v-if="isValidCaptcha">
          <span class="t-title">{{ $t("paygame.captcha") }}</span>
          <div class="code-box">
            <input
              class="code-input"
              v-model="data.captcha_code"
              v-on:input="getInput($event.target.value)"
              maxlength="4"
              :placeholder="$t('paygame.insertCaptcha')"
            />
            <div
              class="code-img"
              @click="getImage"
              :style="{ 'background-image': 'url(' + data.imgUrl + ')' }"
              ga-data="2701005"
            >
              <div class="captcha-loading" v-show="!data.imgUrl"></div>
              <div class="cover-text">
                <span>{{ $t("paygame.change") }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="errMsg" v-if="type === 1 && message">
        <span class="err-text">{{ message }}</span>
      </div>
      <div class="btn btn-submit" @click="submit" :ga-data="gadataBtn">
        <span>{{ btnText }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1, // 1: 确认支付 2:支付成功
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    message: {
      type: String,
    },
    isValidCaptcha: {
      type: Boolean,
    },
  },
  computed: {
    // 标题
    title() {
      return this.type === 1
        ? this.$t("paygame.payConfirm")
        : this.$t("paygame.paySuccess");
    },
    gadata() {
      return this.type === 1 ? "2704002" : "2706002";
    },
    gadataBtn() {
      return this.type === 1 ? "2704001" : "2706001";
    },
    tipInfo() {
      return this.type === 1
        ? this.$t("paygame.payTip1")
        : this.$t("paygame.payTip2");
    },
    btnText() {
      return this.type === 1
        ? this.$t("paygame.payConfirm1")
        : this.$t("paygame.viewHistore");
    },
  },
  methods: {
    // 关闭弹窗
    closeModal() {
      this.$emit("closeModal");
    },
    // 输入验证码
    getInput(val) {
      this.$emit("getInput", val);
    },
    // 获取徒刑验证码
    getImage() {
      this.$emit("getImage");
    },
    closeOrderConfirm() {
      this.$emit("closeOrderConfirm");
    },
    // 创建订单
    submit() {
      if (this.type === 1) {
        this.$emit("createOrder");
      } else {
        this.$router.push({ path: "/paygame_history" });
      }
    },
  },
};
</script>
